export default "__VITE_ASSET__D8s_DP62__"